export default function initContactForm() {
  const educationalInstitution =
    document.getElementsByName('select-5');
  const organisationInput = document.getElementById('text-1');

  if (!educationalInstitution || !organisationInput) {
    return;
  }

  educationalInstitution[0].addEventListener('change', function (e) {
    organisationInput.classList.toggle(
      'hidden-field',
      e.target.value !== ''
    );
  });
}
